import axiosInstance from "@/api/axios-instance";
import { RegionFormData } from "../schema/region-schema";
import { Region } from "../types/region";

export async function updateRegion(id: string, data: Partial<RegionFormData>) {
  const response = await axiosInstance.patch<Region>(`/region/${id}`, data);
  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update region");
  }
  return response.data;
}
